import { MapService } from './services/map.service';
import { DataService } from './services/data.service';
import { RegionsService } from './services/regions.service';
import { ChartsService } from './services/charts.service';
import { UIService } from './services/ui.service';
import { UrlService } from './services/url.service';

export class App {
  constructor() {
  }

  initialize() {

    let urlService = new UrlService();

    let mapService = new MapService();
    mapService.initialize();

    let dataService = new DataService();

    let regionsService = new RegionsService({
      urlService: urlService
    });

    let uiService = new UIService({
      urlService: urlService
    });

    let chartsService = new ChartsService();

  }
}